import { syncRender } from 'globalCommon/services/syncRender';
import { getDesktopClientDownloadLink } from 'globalCommon/utils/index';
import Toast from 'globalCommon/utils/toast';
import commonPageService from 'mCommon/services/commonPageService';
import './style.css';

function init() {
    env();
    commonPageService({ renderAfter: syncRender });
    initCopy();
}

async function initCopy() {
    const downloadLink = await getDesktopClientDownloadLink();
    const downloadClientBtn = document.getElementById('download-desktop-client-btn');
    downloadClientBtn?.setAttribute('href', downloadLink);

    const copyBtn = document.getElementById('copy-download-link');

    if (copyBtn) {
        const clipboard = new ClipboardJS(copyBtn, {
            text: function () {
                return downloadLink;
            },
        });
        clipboard.on('success', function () {
            Toast('複製成功');
        });
    }
}

function env() {
    const el = document.querySelector('body');
    if (!el) {
        return;
    }
    if (/wxwork/i.test(window.navigator.userAgent)) {
        el.classList.add('env-wxwork');
        el.classList.remove('env-common');
    } else {
        el.classList.add('env-common');
        el.classList.remove('env-wxwork');
    }
}

init();
